var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabyChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7523_10823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7405 30.8336L21.7383 14.2773H22.1781C22.7532 14.2773 23.2195 13.8111 23.2195 13.2359C23.2195 12.6608 22.7532 12.1946 22.1781 12.1946H20.374V8.79279C20.374 7.30648 19.1649 6.09723 17.6785 6.09723H10.8622V1.04136C10.8622 0.466208 10.396 0 9.82087 0C9.24572 0 8.77952 0.466208 8.77952 1.04136V13.2358C8.77952 13.811 9.24572 14.2772 9.82087 14.2772H10.2607L8.25862 30.8336C8.18952 31.4046 8.59645 31.9234 9.16743 31.9924C9.20994 31.9975 9.25202 32 9.29379 32C9.81297 32 10.2624 31.6121 10.3263 31.0835L10.4613 29.9674H21.5377L21.6727 31.0835C21.7367 31.612 22.1859 32 22.7052 32C22.7469 32 22.789 31.9975 22.8315 31.9924C23.4026 31.9233 23.8096 31.4046 23.7405 30.8336ZM17.0409 8.17994H17.6786C18.0165 8.18005 18.2914 8.45486 18.2914 8.79279V12.1946H17.0409V8.17994ZM13.7078 8.17994H14.9582V12.1946H13.7078V8.17994ZM12.3589 14.2772H19.6404L20.1063 18.1291H11.8931L12.3589 14.2772ZM10.8623 8.18005H11.625V12.1947H10.8623V8.18005ZM10.7132 27.8849L11.6412 20.2121H20.358L21.2859 27.8849H10.7132Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7523_10823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyChair);
export default __webpack_public_path__ + "static/media/babyChair.9123c3b15e4727d99bc9aa088d270591.svg";
export { ForwardRef as ReactComponent };